import clsx from 'clsx'
import { useField } from 'formik'
import React from 'react'

import { InputContainer } from '../Input/Input.styles'
import { DateInput } from '.'

interface Props {
  className?: string
  inputType?: 'datetime-local' | 'time' | 'date'
  label?: string
  name: string
}

export const DateInputControlled = ({ className = '', name, label }: Props) => {
  const [field, { touched, error }, { setError, setValue }] = useField({ name, type: 'date' })

  const isError = touched && !!error

  const handleChange = (value: Date) => {
    setValue(value)
    setError(undefined)
  }

  return (
    <InputContainer className={className} isError={isError}>
      {label && (
        <label className="mb-2 font-medium leading-120 text-primary" htmlFor={name}>
          {label}
        </label>
      )}
      <DateInput handleChange={handleChange} value={field?.value} />

      <div className={clsx('flex w-full', isError ? 'justify-between' : 'justify-end')}>
        {isError && <p className="mt-1 font-medium text-label-xs text-tertiary">{error}</p>}
      </div>
    </InputContainer>
  )
}
